import React, { useEffect, useState } from 'react';
import { Flex, useToast } from '@chakra-ui/react';
import Sidebar from '../components/Sidebar.js';
import DashboardFooter from '../components/DashboardFooter.js';
import DashboardNavbar from '../components/DashboardNavbar.js';
import { useParams } from 'react-router-dom';
import MentorService from '../services/mentor-service';
import {
  MentorProfile,
  MentorProfileSkeleton,
} from '../components/MentorProfile';
import { Mixpanel } from '../utils/Mixpanel.js';
import withRouter from '../utils/withRouter.js';

const Mentor = () => {
  Mixpanel.track('Mentor Detail Page');
  const toast = useToast();
  const username = useParams().username;
  const [mentor, setMentor] = useState('');

  const getMentorDetails = async () => {
    try {
      const response = await MentorService.getMentor(username);
      setMentor(response.data.mentor);
    } catch (err) {
      toast({
        title: 'Something went wrong.',
        description: `We are unabled to get the mentor profile you requested, please try again later.`,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getMentorDetails();
  }, [username, toast]);

  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-white">
        <DashboardNavbar
          title="Mentor Profile"
          hideBecomeAMentorButton={true}
        />
        {/* Header */}
        <div className="px-4 md:px-10 mx-auto w-full py-8">
          <div className="flex flex-wrap mt-4">
            <div className="w-full mb-12 xl:mb-0 px-4">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded">
                <div className="w-full rounded-t mb-0 border-0">
                  {mentor ? (
                    <Flex rounded="lg" direction="column" width={'100%'}>
                      <MentorProfile mentor={mentor} />
                    </Flex>
                  ) : (
                    <Flex
                      shadow="lg"
                      rounded="lg"
                      mt="100px"
                      direction="column"
                      width={'100%'}
                    >
                      <MentorProfileSkeleton />
                    </Flex>
                  )}
                </div>
              </div>
            </div>
          </div>
          <DashboardFooter />
        </div>
      </div>
    </>
  );
};

export default withRouter(Mentor);
